import { forEach } from 'lodash-es';

/**
 * In-memory cache of presigned S3 URLs, keyed by S3 key, shared by every component that renders activity files.
 * It lives outside the activity layout so filling it is never a layout change, and works the same whether or not the
 * layout is frozen. Callers still check `isPresignedUrlExpired` before reusing a URL. Cleared on logout.
 */
const presignedUrls = new Map<string, string>();

export const getCachedPresignedUrl = (s3Key: string | null | undefined): string | undefined =>
    s3Key ? presignedUrls.get(s3Key) : undefined;

export const cachePresignedUrl = (s3Key: string | null | undefined, url: string | null | undefined): void => {
    if (s3Key && url) {
        presignedUrls.set(s3Key, url);
    }
};

/** Seeds the cache with the `{ s3Key: presignedUrl }` map extracted from an API response by `getPresignedUrls`. */
export const cachePresignedUrls = (urls: Record<string, string | null | undefined>): void => {
    forEach(urls, (url, s3Key) => cachePresignedUrl(s3Key, url));
};

export const clearPresignedUrlCache = (): void => {
    presignedUrls.clear();
};
